import { Box, Stack, Typography } from '@mui/material';
import { GlassPanel } from '../../../shared/components/GlassPanel';
import type { AiAssistantRole } from '../../../core/types/data-models';
import { FlowProgressRing } from './FlowProgressRing';
import { FlowStageCard } from './FlowStageCard';
import type { FlowStage } from './flowStages';

/** "Flow progress" row — a donut chart summarizing overall document-generation
 * progress across the 4 flow categories, and a row of cards breaking that same
 * total down per category (documents generated / active document types).
 * Mirrors the console-mock's "Flow progress" card, minus its "Open flow" action. */
export function FlowProgressSection({
  stages,
  percent,
  roles,
}: {
  stages: FlowStage[];
  percent: number;
  roles: AiAssistantRole[];
}) {
  const roleByCategory = new Map(roles.map((r) => [r.documentCategoryType, r]));
  return (
    <GlassPanel sx={{ p: 2.5 }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.25 }}>
        Flow progress
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2.5 }}>
        Each stage feeds the next — tracked by generated documents per category.
      </Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems="center">
        <FlowProgressRing percent={percent} />
        <Box sx={{ flex: 1, minWidth: 0, width: '100%', display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
          {stages.map((stage) => (
            <FlowStageCard key={stage.categoryType} stage={stage} role={roleByCategory.get(stage.categoryType)} />
          ))}
        </Box>
      </Stack>
    </GlassPanel>
  );
}
